import axios from 'axios';
import BaseUrl from './BaseUrl';

const AxiosConfig = () => {	

	let token = localStorage.getItem('userToken');
	
	const AuthHeader = {
		// 'Content-Type': 'application/json',
		// 'Accept': 'application/json',
		'Authorization': `Bearer ${token}`,
		'X-localization': localStorage.getItem("activeLanguage")
	};

	return axios.create({
		baseURL: `${BaseUrl}api/`,
		headers: AuthHeader
	});
}


export default AxiosConfig